import {ElementType, ReactNode, forwardRef} from 'react';

interface CrumbProps {
    children?: ReactNode;
    active?: boolean;
    as?: ElementType;
    asProps?: object;
}

export const Crumb = forwardRef(({children, active = false, as: Link = 'a', asProps, ...props}: CrumbProps, ref) => {
    return (
        <Link {...props} {...asProps} ref={ref}>
            {children}
        </Link>
    );
});
